import React, { useState } from 'react';
import { FMessage } from '../../hoc/IntlComponents';
import IntlInput from '../common/IntlInput';
import CustomControl from '../CustomControl/CustomControl';
import ContractsInput from './ContractsInput';

const ContractsSEForm = ({ getCommonProps, disabled: globalDisabled, customCheckBoxId }) => {
  const [isMatch, setIsMatch] = useState(false);

  const handleChangeMatch = () => {
    setIsMatch((prev) => !prev);
    const inputHandler = getCommonProps('actual_address', 1).onChange;
    const addresToCopyProps = getCommonProps('address', 2);
    const data = { name: 'actual_address', value: '' };
    if (!isMatch) {
      data.value = addresToCopyProps.value;
    }
    inputHandler({ target: data });
  };

  const getActAddressProperty = (prop) => {
    const addresToCopyProps = getCommonProps('address', 1);
    const propsToReplace = getCommonProps('actual_address', 0);
    return isMatch ? addresToCopyProps[prop] : propsToReplace[prop];
  };

  const getActAddressCommonProps = () => {
    const { disabled, ...restProps } = getCommonProps('actual_address', 0);
    return {
      ...restProps,
      disabled: setIsMatch || globalDisabled,
    };
  };

  return (
    <>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('name', 0)} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('inn')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('bik')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('bank_account')} />
      </ContractsInput>
      <ContractsInput className="contracts-document-name" colProps={{ md: 12 }}>
        <FMessage id="contracts.document.name" />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('document_serial')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('document_number')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('document_unit_name')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('document_date')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('document_unit_code')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('birthday')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('address', 2)} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput
          className="form-group-upper-label"
          {...getActAddressCommonProps()}
          value={getActAddressProperty('value')}
          error={getActAddressProperty('error')}
          noErrorText
        >
          <div className="contracts-match-checkbox-wrapper">
            <CustomControl
              id={customCheckBoxId}
              className="custom-control-xs isMatch"
              name={customCheckBoxId}
              value={customCheckBoxId}
              onChange={handleChangeMatch}
              checked={isMatch}
              disabled={globalDisabled}
            >
              <FMessage id="contracts.match.type-3" />
            </CustomControl>
          </div>
        </IntlInput>
      </ContractsInput>
      {/* <ContractsInput colProps={{ md: 12 }}>
        <IntlInput {...getCommonProps('actual_address', 1)} />
      </ContractsInput> */}
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('email')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 6 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('phone')} />
      </ContractsInput>
      <ContractsInput colProps={{ md: 12 }}>
        <IntlInput className="form-group-upper-label" {...getCommonProps('edo_id')} />
      </ContractsInput>
    </>
  );
};

export default ContractsSEForm;
